import React, { Component } from "react";
import * as s from "./SimpleDocumentCard.module.scss";
import { Col, P, BackgroundImage, DynamicLink } from "src/views/shared/components";
import { ISingleWordpressDocument } from "src/models";
import { truncate } from "src/libs/utils";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  document: ISingleWordpressDocument;
  hidden: boolean;
}

export class SimpleDocumentCard extends Component<Props> {
  render() {
    const { document, hidden, className, ...rest } = this.props;
    const {
      documentThumbnail,
      title,
      link,
      documentFields,
      documentPublishers
    } = document;
    const { image } = documentThumbnail || {};
    const { publicationYear } = documentFields;
    const { publishers } = documentPublishers || {};
    let documentCardContainerClasses = [s.documentCardColumn];

    if (hidden) {
      documentCardContainerClasses.push(s.hidden);
    }

    if (className) {
      documentCardContainerClasses.push(className);
    }

    return (
      <Col xs={6} lg={3} className={documentCardContainerClasses.join(" ")} {...rest}>
        <DynamicLink to={link} className={s.documentCardLink}>
          <div className={s.image}>
            <BackgroundImage image={image} />
          </div>
          {title && (
            <P medium className={s.documentTitle}>
              {truncate(title, 75)}
            </P>
          )}
          <div className={s.publishingInformation}>
            <P small className={s.publishingInformationLabel}>
              {publicationYear}
              {publicationYear && publishers?.[0] && " · "}
              {publishers?.[0]?.name}
            </P>
          </div>
        </DynamicLink>
      </Col>
    );
  }
}
